/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-23 22:37:52
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import DataAuditApi from './api/dataAuditApi';
import { createBEM, createNamespace } from 'src/util/bem';
import Input from 'src/types/iview/Input';

import CommonSelect from '../../../components/SelectCustom/commonSelect';
import EnumPriorityLevel from './EnumPriorityLevel';

let bem = createBEM('audit-maintenance');
export namespace AuditMaintenanceVOI {
    export interface PropsI {
        code: string;
        name: string;
        order: string;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        code: string;
        name: string;
        order: string;
    }
}

@Component
class AuditMaintenanceModal extends Vue.Component<AuditMaintenanceVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: String,
    })
    sheetNumber!: string;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: AuditMaintenanceVOI.FormDataI = {
        code: '',
        name: '',
        order: '',
    };
    rules: any = {
        name: [{ required: true, message: '请输入名称', trigger: 'change' }],
    };

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (!this.formData.code) {
            return Toast.error('请填写标识代码');
        }
        if (!this.formData.name) {
            return Toast.error('请填写标识名称');
        }
        if (!this.formData.order) {
            return Toast.error('请填写优先级别');
        }
        this.loading = true;
        // * API 新增无效标识集
        let res = await DataAuditApi.InvalidIdentifiersAdd({
            code: this.formData.code,
            name: this.formData.name,
            priority_level: this.formData.order,
        });
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success(this.operate + '成功');
            this.saveSuccess();
            this.closeModal();
        }
    }

    render(h) {
        return (
            <Modal title={this.operate + '无效标识'} width="800" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                <i-form ref="formValidate" labelWidth={140} class={createNamespace('detail-form')} model={this.formData}>
                    <form-item labelWidth={130} label="标识代码" style="display: block;width:50%;padding-bottom: 10px;">
                        <Input v-model={this.formData.code} type="text" />
                    </form-item>
                    <form-item labelWidth={130} label="标识名称" style="display: block;width:50%;padding-bottom: 10px;">
                        <Input v-model={this.formData.name} type="text" />
                    </form-item>
                    <form-item labelWidth={130} label="优先级别" style="display: block;width:50%;">
                        <CommonSelect dataSource={EnumPriorityLevel.getList()} v-model={this.formData.order} />
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function auditAddInvalidModal(operate: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<AuditMaintenanceVOI.PropsI>(AuditMaintenanceModal)({
            operate,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
